<template>
    <Sheet v-loading="loading.actions['history']">
        <el-divider>
            <span style="font-size:1.1rem;padding-right: 10px;">
               本學期申請紀錄
            </span>
        </el-divider>
        <el-button
                   icon="el-icon-refresh-right"
                   @click="refresh"
                   :loading="loading.actions['history']">
            重新載入
        </el-button>
        <el-table
                :stripe="true"
                :data="pagedForms"
                empty-text="本學期無申請紀錄"
                height="620px"
                row-key="formNo"
        >
            <el-table-column
                    label="表單編號"
                    prop="formNo">
            </el-table-column>
            <el-table-column
                    label="申請時間"
                    prop="createdAt"
            ></el-table-column>
            <el-table-column
                    label="教室"
                    prop="roomName"
            ></el-table-column>
            <el-table-column
                    label="狀態"
                    prop="status"
            >
            </el-table-column>
            <el-table-column
                    label="異動"
            >
                <template #default="{row}"
                >
                    {{row.changeLogs.join('; ')}}
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template #default="{row}">
                    <el-button
                            type="primary"
                            @click="selectAndShow(row)"
                    >
                        詳細
                    </el-button>
                    <el-button
                            type="warning"
                            :disabled="!row.cancelable"
                            @click="cancel(row)"
                    >取消申請
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="history.length"
                :page-size="pageSize"
                @current-change="page => pageChange(page, history)"
                :current-page.sync="currentPage"
        ></el-pagination>
        <el-dialog
                :visible.sync="show"
                :title="title"
                top="5vh"
                v-if="show"
        >
            <form-detail :form="selectedForm"></form-detail>
            <div v-if="isDenied">
                <el-divider>退件原因</el-divider>
                <div style="margin-bottom: 10px;">
                    <el-input
                            :value="denyReason"
                            type="textarea"
                            disabled
                    ></el-input>
                </div>
            </div>
            <template #footer>
                <el-button @click="show = false">關閉</el-button>
            </template>
        </el-dialog>
    </Sheet>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import formTableMixin from '../../formTableMixin';


    export default {
        name: 'History',
        data: () => ({
        }),
        mixins:[formTableMixin],
        computed: {
            ...mapState('history', ['history']),
            ...mapState(['loading'])
        },
        watch: {
            history(current){
                this.pagedForms = this.pageData(current, 1);
            }
        },
        methods: {
            ...mapActions('history', {
                getHistory: 'getHistoryAction',
                cancelForm: 'cancelFormAction'
            }),
            async cancel({id}) {
                try {
                    await this.$confirm('確定要取消嗎?', {
                        type: 'warning',
                    });
                    const {success} = await this.cancelForm(id);

                    if (success) {
                        this.$message.success('取消成功');
                    } else {
                        this.$message.warning('取消失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },
            async refresh(){
                await this.getHistory();
            }
        },
        async created() {
            await this.getHistory();
        }
    }
</script>

<style>

</style>